module.exports = __webpack_public_path__ + "media/images/new_home/business-list-bg-2e3e34ed3a2f7534332750aad0d6d0a7.png";